import React, { useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { KTSVG, SimpleAlert } from '../../../../../rbts/helpers';
import { guardarTurnoService } from '../../../../service/catalogos/Turno';
import { useObtenerTurnoPorId } from '../hooks/TurnoHook';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  id_row: number;
};

const CreateModal: React.FC<Props> = ({ id_row, show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const { initValues } = useObtenerTurnoPorId(id_row);

  const schema = Yup.object().shape({
    nombre: Yup.string()
      .trim()
      .required('El nombre es requerido.')
      .max(50, 'El nombre no puede exceder 50 caracteres.'),
  });

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: schema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        await guardarTurnoService(values);
        SimpleAlert(
          id_row ? 'Turno actualizado exitosamente.' : 'Turno creado exitosamente.',
          3000,
          'success'
        );
        handleClose(true);
        formik.resetForm();
      } catch (error: any) {
        const message = error?.response?.data?.message ?? 'Ocurrió un error.';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  return (
    <Modal
      id="kt_modal_turno"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-500px"
      show={show}
      onHide={() => {
        formik.resetForm();
        handleClose(false);
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>{id_row ? 'Editar turno' : 'Nuevo turno'}</h2>
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            onClick={() => {
              formik.resetForm();
              handleClose(false);
            }}
          >
            <KTSVG className="svg-icon-2" path="/media/icons/duotune/arrows/arr061.svg" />
          </div>
        </div>
        <div className="modal-body mx-5">
          <form onSubmit={formik.handleSubmit}>
            <div className="fv-row mb-7">
              <div className="w-100 d-flex">
                <label className="required fw-bold fs-6 mb-2">Nombre</label>
                {formik.touched.nombre && formik.errors.nombre && (
                  <div className="fv-plugins-message-container text-danger ms-5">
                    <span role="alert">{formik.errors.nombre}</span>
                  </div>
                )}
              </div>
              <input
                placeholder="Ej: Turno Mañana"
                {...formik.getFieldProps('nombre')}
                className="form-control"
                type="text"
                autoComplete="off"
                maxLength={50}
              />
            </div>
            <div className="text-center pt-10">
              <button
                type="reset"
                className="btn btn-light me-3"
                onClick={() => {
                  formik.resetForm();
                  handleClose(false);
                }}
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {!loading ? (
                  <span>{id_row ? 'Actualizar' : 'Guardar'}</span>
                ) : (
                  <span style={{ display: 'block' }}>
                    Espere por favor...
                    <span className="spinner-border spinner-border-sm align-middle ms-2" />
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export { CreateModal };
